import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SlugService {

  constructor() {
  }

  getSlug(): string {
    return location.hostname.split('.')[0];
  }

  isOldHostname(): boolean {
    return location.hostname === 'fornecedores.fieldcontrol.com.br';
  }

  isFieldControlAppBr(): boolean {
    return location.hostname.endsWith('fieldcontrol.app.br');
  }
}
